import { Api } from '../../core/api';

export const referencesApi = new Api({
  initialData: {},
  namespace: 'GET_ALL_REFERENCES',
  url: '/internal-intranet/references',
  useEagleApi: true,
});

export const fetchReferences = referencesApi.fetch;

export const reducer = referencesApi.reducer;
